import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { SpeedInsights } from '@vercel/speed-insights/react';
import ComingSoon from './pages/ComingSoon';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Products from './pages/Products';
import Home from './pages/Home';
import About from './pages/About';
import Book from './pages/Book';
import AppLanding from './pages/AppLanding';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Faq from './pages/Faq';
import Checklist from './pages/Checklist';
import ChecklistDetail from './pages/ChecklistDetail';
import Partners from './pages/Partners';
import NotFound from './pages/NotFound';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieConsentBanner from './components/CookieConsentBanner';
import MobileAppCTA from './components/MobileAppCTA';
import { Helmet } from 'react-helmet';

function NoIndexRoute({ children, title }) {
  return (
    <>
      <Helmet>
        {title ? <title>{title}</title> : null}
        <meta name="robots" content="noindex,nofollow" />
        <meta name="googlebot" content="noindex,nofollow" />
      </Helmet>
      {children}
    </>
  );
}

function MainLayout({ children }) {
  return (
    <div className="min-h-screen bg-transparent">
      <Header />
      {children}
      <Footer />
      <CookieConsentBanner />
      <MobileAppCTA />
    </div>
  );
}

export default function App() {
  return (
    <>
      <Routes>
        <Route
          path="/coming-soon"
          element={
            <NoIndexRoute title="Coming Soon">
              <ComingSoon />
            </NoIndexRoute>
          }
        />

        <Route
          path="/"
          element={
            <MainLayout>
              <Home />
            </MainLayout>
          }
        />
        <Route
          path="/app"
          element={
            <MainLayout>
              <AppLanding />
            </MainLayout>
          }
        />
        <Route
          path="/blog"
          element={
            <MainLayout>
              <Blog />
            </MainLayout>
          }
        />
        <Route
          path="/blog/:slug"
          element={
            <MainLayout>
              <BlogPost />
            </MainLayout>
          }
        />
        <Route
          path="/store"
          element={
            <MainLayout>
              <Products />
            </MainLayout>
          }
        />
        <Route
          path="/about"
          element={
            <MainLayout>
              <About />
            </MainLayout>
          }
        />
        <Route
          path="/privacy"
          element={
            <MainLayout>
              <PrivacyPolicy />
            </MainLayout>
          }
        />
        <Route
          path="/faq"
          element={
            <MainLayout>
              <Faq />
            </MainLayout>
          }
        />
        <Route
          path="/book"
          element={
            <MainLayout>
              <Book />
            </MainLayout>
          }
        />
        <Route
          path="/checklist"
          element={
            <MainLayout>
              <Checklist />
            </MainLayout>
          }
        />
        <Route
          path="/checklist/:slug"
          element={
            <MainLayout>
              <ChecklistDetail />
            </MainLayout>
          }
        />
        <Route
          path="/partners"
          element={
            <MainLayout>
              <Partners />
            </MainLayout>
          }
        />
        <Route
          path="*"
          element={
            <MainLayout>
              <NotFound />
            </MainLayout>
          }
        />
      </Routes>
      <SpeedInsights />
    </>
  );
}
